<template>
  <div class="flex flex-col items-center" data-testid="reviews-empty-view">
    <div class="mb-4">
      <slot name="image" />
    </div>
    <div class="mb-1 text-headline-xs text-main">{{ title }}</div>
    <div class="mb-4 max-w-96 text-center text-label-m text-main" v-html="description" />
    <component
      :is="action.disabled ? 'button' : 'RouterLink'"
      v-if="action"
      class="btn-primary-color-s"
      :disabled="action.disabled"
      :to="action.to"
      data-testid="reviews-empty-view-action"
    >
      {{ action.label }}
    </component>
  </div>
</template>
<script setup lang="ts">
import { type RouteLocationRaw } from 'vue-router'

defineProps<{
  title: string
  description: string
  action?: {
    label: string
    disabled?: boolean
    to: RouteLocationRaw
  }
}>()
</script>
